import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import Drawer from 'components/AntEnhancement/Drawer';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { JobTitle } from 'models';
import services from 'services';
import JobTitleForm from 'components/forms/settings/JobTitleForm';
import './AddJobTitleDrawer.css';
var AddJobTitleDrawer = function (props) {
    var visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, translate = props.translate;
    var jobTitle = useState(function () { return new JobTitle(); })[0];
    var _a = useState(false), saving = _a[0], setSaving = _a[1];
    var onClose = function () { return onCloseDrawer(); };
    var jobTitleService = services.jobTitleService, roleService = services.roleService;
    var roles = roleService.useRoles().data;
    var createJobTitle = jobTitleService.useCreateJobTitle().mutate;
    var onSubmit = function () {
        if (saving)
            return;
        setSaving(true);
        createJobTitle({
            jobTitle: jobTitle,
            successMessage: translate('jobTitles.jobTitleCreated')
        }, {
            onSuccess: function () {
                setSaving(false);
                onClose();
            },
            onError: function () { return setSaving(false); }
        });
    };
    var formKey = "job-title-form-".concat(Number(visiable));
    var roleId = jobTitle.getRoleId();
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: onClose, closable: false, destroyOnClose: true, width: 440, rootClassName: "job-title-drawer", className: "job-title-drawer", children: _jsxs(Form, { layout: "vertical", className: "job-title-drawer__shell", requiredMark: false, onFinish: onSubmit, onValuesChange: function (changed) {
                var _a;
                if (Object.prototype.hasOwnProperty.call(changed, 'title')) {
                    jobTitle.setTitle((_a = changed.title) !== null && _a !== void 0 ? _a : '');
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'role')) {
                    jobTitle.setRoleId(Number(changed.role));
                }
                if (Object.prototype.hasOwnProperty.call(changed, 'baseSalary')) {
                    var value = changed.baseSalary;
                    if (value != null && value !== '') {
                        jobTitle.setBaseSalary(Number(value));
                    }
                }
            }, initialValues: {
                title: jobTitle.getTitle() || '',
                role: Number.isFinite(roleId) && roleId > 0 ? roleId : undefined,
                baseSalary: Number.isFinite(jobTitle.getBaseSalary()) && jobTitle.getBaseSalary() > 0
                    ? jobTitle.getBaseSalary()
                    : undefined
            }, children: [_jsxs("header", { className: "job-title-drawer__header", children: [_jsxs("div", { className: "job-title-drawer__title-block", children: [_jsx("span", { className: "job-title-drawer__dot", "aria-hidden": true }), _jsxs("div", { children: [_jsx("h2", { className: "job-title-drawer__title", children: translate('jobTitles.drawers.addTitle') }), _jsx("p", { className: "job-title-drawer__subtitle", children: translate('jobTitles.drawers.addSubtitle') })] })] }), _jsx("button", { type: "button", className: "job-title-drawer__close", onClick: onClose, "aria-label": translate('common:buttons.close'), children: _jsx(CloseOutlined, {}) })] }), _jsxs("div", { className: "job-title-drawer__body", children: [roles ? _jsx(JobTitleForm, { roles: roles, jobTitle: jobTitle }) : null, _jsxs("p", { className: "job-title-drawer__note", children: [_jsxs("strong", { children: [translate('jobTitles.drawers.noteLabel'), " "] }), translate('jobTitles.drawers.note')] })] }), _jsxs("footer", { className: "job-title-drawer__footer", children: [_jsx("button", { type: "button", className: "job-title-drawer__btn job-title-drawer__btn--ghost", onClick: onClose, children: translate('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "job-title-drawer__btn job-title-drawer__btn--primary", disabled: saving || !roles, children: [_jsx(CheckOutlined, {}), _jsx("span", { children: saving
                                        ? translate('jobTitles.drawers.saving')
                                        : translate('jobTitles.drawers.save') })] })] })] }, formKey) }));
};
export default localeTranslator(AddJobTitleDrawer, 'settings');
